/**
 * Converts an SVG string to a base64 URI string.
 * @param svgString - The SVG string to convert.
 * @returns The base64 URI string.
 *
 * @example
 * const svgString = '<svg width="100" height="100"><circle cx="50" cy="50" r="40" /></svg>';
 * const base64URI = svgToBase64URI(svgString);
 * console.log(base64URI); // Output: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNDAiLz48L3N2Zz4="
 */
export default function svgToBase64URI(svgString: string) {
	const cleanedSvgString = svgString
		.replace(/[\r\n]/g, "")
		.replace(/\s+/g, " ")
		.replace(/>\s+</g, "><");

	return `data:image/svg+xml;base64,${btoa(cleanedSvgString)}`;
}
